import {Component, Inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './dialog-error.component.html',
    styleUrls: ['./dialog-error.component.scss'],
    standalone: false
})
export class DialogErrorComponent implements OnDestroy {
    quiteTimeVal = 'none';
    seconds: string[] = ['none', '10', '60', '300', '3600', '86400'];
    defaultSelected = 0;
    selection: number;
    timer;
    timerValue = 10;

    constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: { message: string; status?: number }) {
        this.timer = setInterval((v) => {
            this.timerValue = this.timerValue - 1;
            if (this.timerValue === 0) {
                this.onClose();
            }
        }, 1000);
    }

    onClose() {
        this.dialogRef.close(this.quiteTimeVal);
    }

    ngOnDestroy() {
        clearInterval(this.timer);
    }
}
